module.exports = __webpack_public_path__ + "static/media/02-about.5692abd5.png";